import { action } from 'satcheljs';
import type { HeaderPaneName } from 'owa-app-pane-group-types';
import type { HeaderPaneActionMessage } from '../types/HeaderPaneActionMessage';

export const onOpenHeaderPane: (
    headerPaneName: HeaderPaneName,
    targetWindow?: Window
) => HeaderPaneActionMessage = action(
    'onOpenHeaderPane',
    (headerPaneName: HeaderPaneName, targetWindow: Window = window): HeaderPaneActionMessage => ({
        headerPaneName,
        targetWindow,
    })
);
